import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=c0ff984e&scoped=true"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"
import style0 from "./Slider.vue?vue&type=style&index=0&id=c0ff984e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ff984e",
  null
  
)

export default component.exports